import maxmodalLogo from "../../assets/images/logos/maxmodaLogo.webp";
import neoLogo from "../../assets/images/logos/neoLogo.png";
import nettoLogo from "../../assets/images/logos/nettoLogo.png";
import pittarelloLogo from "../../assets/images/logos/pittarelloLogo.png";
import reebokLogo from "../../assets/images/logos/Reebok-Logo.svg";
import rutaLogo from "../../assets/images/logos/rutaLogo.png";
import useGrandPoloLogo from "../../assets/images/logos/usGrandPoloLogo.png";
import usPoloAssnLogo from "../../assets/images/logos/usPoloAssn.png";
import abarthLogo from "../../assets/images/logos/abarthLogo.png";
import aeonLogo from "../../assets/images/logos/AEON_logo.png";
import beveleryHillsPoloLogo from "../../assets/images/logos/beverlyHillsPoloLogo.webp";
import closeUpApparelLogo from "../../assets/images/logos/closeUpApparel.png";
import coverimLogo from "../../assets/images/logos/coverimLogo.jpg";
import diadoraLogo from "../../assets/images/logos/Diadora_logo.png";
import filaLogo from "../../assets/images/logos/FilaLogo.webp";
import { motion } from "framer-motion";

const PartnerHome = () => {
    const partners = [
        { name: "Maxmodal", source: maxmodalLogo },
        { name: "Neo", source: neoLogo },
        { name: "Netto", source: nettoLogo },
        { name: "Pittarello", source: pittarelloLogo },
        // { name: "Reebok", source: reebokLogo },
        { name: "Ruta", source: rutaLogo },
        { name: "Us Grand Polo", source: useGrandPoloLogo },
        { name: "Abarth", source: abarthLogo },
        { name: "Aeon", source: aeonLogo },
        { name: "Beverly Hills Polo", source: beveleryHillsPoloLogo },
        { name: "Close Up Apparel", source: closeUpApparelLogo },
        { name: "Coverim", source: coverimLogo },
        { name: "Diadora", source: diadoraLogo },
        { name: "Fila", source: filaLogo },
        { name: "Us Polo Association", source: usPoloAssnLogo },
    ];

    // Duplicate the images to create a seamless effect
    const logos = [...partners, ...partners];

    return (
        <div className="partnerHome pt-4 pb-8 w-full flex flex-col items-center gap-2 shadow-lg mb-2">
            <h1 className="text-center text-lg font-merriweather font-bold text-[#324797]">Our Partners</h1>
            <div className="carousel flex flex-row bg-white/60 py-8 w-[80%] overflow-hidden gap-4 relative bg-gradient-to-l from-transparent via-white to-transparent">
                {/* Fade Effect Overlay */}
                <div className="absolute inset-0  w-[80%] overflow-hidden "></div>
                <motion.div
                    className="carousel-track"
                    animate={{ x: ["0%", "-100%"] }} // Moves left continuously
                    transition={{
                        repeat: Infinity,
                        ease: "linear",
                        duration: 50, // Adjust speed
                    }}
                >
                    {logos.map((partner, index) => (
                        <img
                            key={index}
                            src={partner.source}
                            alt={partner.name}
                            className="h-[60px] grayscale-logo cursor-auto"
                        />
                    ))}
                </motion.div>
                {/* Fade Effect Overlay */}
                
            </div>
        </div>
    );
};

export default PartnerHome;
